var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M955,535H45c-19.3,0-35-15.7-35-35c0-19.3,15.7-35,35-35h910c19.4,0,35,15.7,35,35C990,519.3,974.4,535,955,535 M850,955h-193c-19.4,0-35-15.6-35-35c0-19.4,15.7-35,35-35h193c19.3,0,35-15.7,35-35V675c0-19.4,15.7-35,35-35c19.4,0,35,15.6,35,35v175C955,907.9,907.9,955,850,955 M349.4,955H150c-57.9,0-105-47.1-105-105V675c0-19.4,15.7-35,35-35s35,15.6,35,35v175c0,19.3,15.7,35,35,35h199.4c19.4,0,35,15.7,35,35C384.4,939.4,368.7,955,349.4,955 M80,360c-19.3,0-35-15.7-35-35V150C45,92.1,92.1,45,150,45h199.4c19.4,0,35,15.7,35,35c0,19.3-15.7,35-35,35H150c-19.3,0-35,15.7-35,35v175C115,344.3,99.3,360,80,360 M920,360c-19.4,0-35-15.7-35-35V150c0-19.3-15.6-35-35-35h-193c-19.4,0-35-15.7-35-35c0-19.3,15.7-35,35-35h193c57.9,0,105,47.1,105,105v175C955,344.3,939.4,360,920,360"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.3f50da01.svg";
export { ForwardRef as ReactComponent };